{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Whatsapp šablóny",
      "SUBTITLE": "Vyberte Whatsapp šablónu, ktorú chcete odoslať",
      "TEMPLATE_SELECTED_SUBTITLE": "Spracovanie {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Hľadať šablóny",
      "NO_TEMPLATES_FOUND": "Nenašli sa žiadne šablóny pre",
      "LABELS": {
        "LANGUAGE": "Jazyk",
        "TEMPLATE_BODY": "Telo šablóny",
        "CATEGORY": "Kategória"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Premenné",
      "VARIABLE_PLACEHOLDER": "Zadajte hodnotu {variable}",
      "GO_BACK_LABEL": "Späť",
      "SEND_MESSAGE_LABEL": "Odoslať správu",
      "FORM_ERROR_MESSAGE": "Pred odoslaním vyplňte prosím všetky premenné"
    }
  }
}
